import { useState } from 'react'
import { Button, Group, Radio, Stack, Text, TextInput } from '@mantine/core'

// #1130 admin 応募詳細の面談起票フォーム(柱4-2)。Rails の form_with(POST /admin/applications/:job_application_id/interviews)の
// 内側に置き、name 付きの入力を通常のフォーム送信に乗せる。検証・保存・応募者へのメール・Slack 追記は Rails 側。
// - 形式は Radio.Group(Select は Mantine v9.5.2 でドロップダウンが開かない疑いがあるため使わない。see memory: mantine_v9_broken_components)
// - 候補日時はネイティブ <input type="datetime-local">。maxSlots 行まで追加でき、空行は Rails 側で無視される
// - 終了日時は入力させず、Rails 側で「開始日時 + 所要時間」として算出する
// - 自由文の入力欄は置かない(非媒介原則。応募者・企業へ届くのは定型文のみ)
export default function AdminInterviewForm({ formats = [], maxSlots = 5, defaultDurationMinutes = 60, minStartsAt }) {
  const [format, setFormat] = useState(formats[0]?.value ?? 'online')
  const [slots, setSlots] = useState([''])
  const filledCount = slots.filter((value) => value).length

  const updateSlot = (index, value) => setSlots((prev) => prev.map((v, i) => (i === index ? value : v)))
  const removeSlot = (index) => setSlots((prev) => (prev.length === 1 ? [''] : prev.filter((_, i) => i !== index)))
  const addSlot = () => setSlots((prev) => (prev.length < maxSlots ? [...prev, ''] : prev))

  return (
    <Stack gap="md">
      <Radio.Group name="interview[format]" label="面談形式" value={format} onChange={setFormat} required>
        <Group mt="xs" gap="md" wrap="wrap">
          {formats.map((option) => (
            <Radio key={option.value} value={option.value} label={option.label} />
          ))}
        </Group>
      </Radio.Group>

      <Group grow align="flex-start">
        <TextInput
          type="number"
          name="interview[duration_minutes]"
          label="所要時間(分)"
          defaultValue={defaultDurationMinutes}
          min={15}
          step={15}
          required
        />
        <TextInput
          name="interview[location_or_url]"
          label="場所 / URL"
          description="応募者には日時が確定した後にのみ表示されます。"
          placeholder="任意"
        />
      </Group>

      <Stack gap="xs">
        <Text fz="sm" fw={500}>
          候補日時(最大 {maxSlots} 件)
        </Text>
        {slots.map((value, index) => (
          <Group key={index} align="flex-end" gap="xs" wrap="nowrap">
            <TextInput
              type="datetime-local"
              name="interview[slot_proposals_attributes][][starts_at]"
              label={`候補 ${index + 1}`}
              value={value}
              min={minStartsAt}
              step={900}
              onChange={(event) => updateSlot(index, event.currentTarget.value)}
              style={{ flex: 1 }}
            />
            <Button
              type="button"
              variant="subtle"
              color="gray"
              onClick={() => removeSlot(index)}
              disabled={slots.length === 1 && !value}
            >
              削除
            </Button>
          </Group>
        ))}
        <Group>
          <Button type="button" variant="default" onClick={addSlot} disabled={slots.length >= maxSlots}>
            候補を追加
          </Button>
        </Group>
      </Stack>

      <Group justify="space-between" align="center" wrap="wrap">
        <Text fz="sm" c="dimmed">
          提示すると応募者へ候補日時の案内メールが送信され、Slack スレッドに追記されます。
        </Text>
        <Button type="submit" disabled={filledCount === 0}>
          面談候補を提示する
        </Button>
      </Group>
    </Stack>
  )
}
